var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_button",
    "data-name": "Menu button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11.759,
    viewBox: "0 0 14 11.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(-288 -755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 14,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 755)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 14,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 760)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    width: 7,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 765)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDark);
export default __webpack_public_path__ + "static/media/menu-dark.91a8c35c17aa6288fad03eaf3b787273.svg";
export { ForwardRef as ReactComponent };